<template>
  <div class="form-group mb-3">
    <label :for="'input' + inputID" :class="noPadding ? '' : 'text-label'">
      {{ inputLabel }}&nbsp;
    </label>
    <input
      :value="modelValue"
      @input="handleNumberChange"
      class="calc-input-width me-1"
      :id="'input' + inputID"
      :type="type"
    /> 
    {{ unit }}
  </div>
</template>

<script>
//import { ref } from 'vue';
import newId from '../../utils/unique_key';

export default {
  name: 'FreeInput',
  props: {
    inputLabel: {
      type: String,
      required: true,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    unit: {
      type: [String, Number],
      default: ''
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const inputID = newId();

    const handleNumberChange = (event) => {
      emit('update:modelValue', event.target.value);
    };

    return { inputID, handleNumberChange };
  }
};
</script>
